export default {
  SET_APPOINTMENT: '@@IO_ADMIN_RESERVATION/SET_APPOINTMENT',
  BOOK_APPOINTMENT: '@@IO_ADMIN_RESERVATION/BOOK_APPOINTMENT',
  SET_IS_LOADING: '@@IO_ADMIN_RESERVATION/SET_IS_LOADING',
};
